import React, { useEffect, useState } from 'react';
import { unionFlag, getSessonStorage } from '@/utils';
import { withRouter } from 'umi';
import { connect } from 'dva';
import Api from '@/common/api';
import styles from './index.less';
import { Button, Modal, Toast } from 'antd-mobile';
import refundRightArrow from '@/assets/imgs/applyRefund/refundpages_arrow.png';
import refundError from '@/assets/imgs/applyRefund/applyRefund_error.png';
import { ReplaceText, TLang, CheckCN, getCookie} from '@/utils/lang';
import NavBar from '@/components/NavBar';

const ApplyRefund = ({unionConfig}) => {
  const [params] = useState<any>(JSON.parse(sessionStorage.getItem('refundDetail') || '{}') || {});
  const [refundReasonModal, setRefundReasonModal] = useState(false);
  const [confirmRefund, setConfirmRefund] = useState(false);
  const [reasonKey, setReasonKey] = useState('');
  const [refundReason, setRefundReason] = useState([]);
  const unionCode = unionFlag() || getSessonStorage('dffl_union');
  const [union] = useState(unionCode && typeof unionCode !== 'undefined');

  const handleSelectRefundReason = (key) => {
    setRefundReasonModal(false);
    setReasonKey(key);
  };

  const getPrice = (price): string => {
    if (union) {
      // price
      let p = (price / 100) * unionConfig.union_scale;
      return p.toFixed(2);
    } else {
      let p = price / 100;
      return p.toFixed(2);
    }
  };

  useEffect(() => {
    const array: any = [];
    for (const key in params.refundReason) {
      if (Object.prototype.hasOwnProperty.call(params.refundReason, key)) {
        const element = params.refundReason[key];
        const item = {
          value: element,
          key: key
        };
        array.push(item);
      }
    }
    setRefundReason(array);
  }, []);

  const applyRefundClick = () => {
    setConfirmRefund(false);
    Api.NonInferiorCardApplyRefund({
      orderSn: params.orderSn,
      price: params.price,
      refundAmount:params.refundAmount,
      refundReason: reasonKey,
      totalServiceCharge: params.totalServiceCharge
    }).then((res) => {
      if (res) {
        sessionStorage.setItem('applyRefundDetail', JSON.stringify(res));
        window.df_sdk_common.location.replace(`/newmovie/applyRefundDetail?orderSn=${params.orderSn}`);
      }
    });
  };

  const handleConfirm = () => {
    if (!reasonKey) {
      return;
    }
    if (params.count > 0 && params.totalServiceCharge > 0) {
      Api.inferiorCardApplyRefund({
        count: params.count,
        orderSn: params.orderSn,
        price: params.price,
        refundAmount: params.refundAmount,
        refundReason: reasonKey,
        totalServiceCharge: params.totalServiceCharge
      }).then((res) => {
        if(res) {
          window.df_sdk_common.location.replace(res.payUrl);
        }
      });
    } else if(params.count > 0 && params.totalServiceCharge == 0) {
      Api.NonInferiorCardApplyRefund({
        count: params.count,
        orderSn: params.orderSn,
        price: params.price,
        refundAmount:params.refundAmount,
        refundReason: reasonKey,
        totalServiceCharge: params.totalServiceCharge
      }).then((res) => {
       if (res) {
        sessionStorage.setItem('applyRefundDetail', JSON.stringify(res));
        window.df_sdk_common.location.replace(`/newmovie/applyRefundDetail?orderSn=${params.orderSn}`);
       }
      });

    } else {
      setConfirmRefund(true);
    }
  };

  return (
    <div className={styles.applyRefund}>
      <NavBar isShowMenu showService={false} text={TLang('申请退款', 'home', false, false, null)} initColor="#333" targetColor="#333" targetBgColor="#FFF" opacity={1} />
      <div className={styles.applyRefund_money}>
        <div className={styles.applyRefund_money_top}>
          <div className={styles.applyRefund_money_title}>{TLang('退款金额', 'home', false, false, null)}</div>
          <div className={styles.applyRefund_money_price}>
            {params.count > 0 && params.price
            ? `${ReplaceText('X', params.count, TLang('X次', 'home', false, false, null), false)} + ${getPrice(params.price)}${TLang('福豆', 'home', false, false, null)}`
            : params.count > 0 ? `${ReplaceText('X', params.count, TLang('X次', 'home', false, false, null), false)}` : `${getPrice(params?.refundAmount)}${TLang('福豆', 'home', false, false, null)}`
            }
          </div>
          <div className={styles.applyRefund_money_explain}>{TLang('预计1-7个工作日，退款金额将原路退回到您的支付账户', 'home', false, false, null)}</div>
        </div>
        <div className={styles.applyRefund_money_bottom}>
          <div className={styles.applyRefund_money_orderPrice}>
            {params.count > 0 && params.price
            ? `${TLang('订单金额', 'home', false, false, null)} ${params.count}次 + ${getPrice(params?.price)}${TLang('福豆', 'home', false, false, null)}`
            : params.count > 0 ? `${TLang('订单金额', 'home', false, false, null)} ${params.count}次` : `${TLang('订单金额', 'home', false, false, null)} ${getPrice(params?.price)}${TLang('福豆', 'home', false, false, null)}`
            }
          </div>
          <div className={styles.applyRefund_money_refundServicePrice}>{TLang('退票服务费', 'home', false, false, null)} {getPrice(params?.totalServiceCharge)}{TLang('福豆', 'home', false, false, null)}</div>
          <div className={styles.applyRefund_money_refundServiceExplain}>{params?.serviceChargeExplain}</div>
        </div>
      </div>
      <div className={styles.applyRefund_reson}>
        <div className={styles.applyRefund_reson_title}>{TLang('退款原因', 'home', false, false, null)}<span>{TLang('（必填）', 'home', false, false, null)}</span></div>
        <div className={styles.applyRefund_reson_explain} onClick={() => setRefundReasonModal(true)}>
          <div className={styles.applyRefund_reson_explain_left} style={{color: params?.refundReason[reasonKey] ? '#333' : '#999'}}>{params.refundReason[reasonKey] || `${TLang('请放心选择，不影响退款申请哦', 'home', false, false, null)}`}</div>
          <div className={styles.applyRefund_reson_explain_right}><img  src={refundRightArrow}/></div>
        </div>
      </div>
      <div className={styles.applyRefund_button}>
        {params.count > 0 && <div className={styles.applyRefund_button_tips}>{TLang('次卡兑换的退票服务费需要单独支付', 'home', false, false, null)}</div>}
        <div
          style={{ opacity: reasonKey == '' ? '0.5' : '1'}}
          className={`${styles.applyRefund_button_style} ${getCookie('df_lang')==='en-US' ? styles.applyRefund_button_button : ''}`}
          onClick={() => {handleConfirm();}}
        >
          {params.count > 0 && params?.totalServiceCharge > 0
          ? `${ReplaceText('X', getPrice(params?.totalServiceCharge), TLang('去支付 X福豆 并确认退票', 'home', false, false, null), false)}`
          : TLang('提交', 'home', false, false, null)
          }
        </div>
      </div>
      <div className={styles.applyRefund_tips}>{TLang('提交申请后不可撤销哦', 'home', false, false, null)}</div>
      <Modal
        popup
        visible={refundReasonModal}
        maskClosable={false}
        animationType="slide-up"
        className="refundReasonModal"
        onClose={() => setRefundReasonModal(false)}
      >
        <div className="refundReasonModal_content">
          <div className="refundReasonModal_title">{TLang('退款原因', 'home', false, false, null)}</div>
          <div className="refundReasonModal_exitIcon" onClick={() => setRefundReasonModal(false
            )}
          ><img src={refundError}/></div>
          <div className="refundReasonModal_text">{TLang('请放心选择，不影响退款申请哦', 'home', false, false, null)}</div>
          <div className="refundReasonModal_list">
            {refundReason?.map((item: any) => (
              <div
                key={item?.key}
                style={{ color: item?.key == reasonKey ? window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF' : '#333333'}}
                className="refundReasonModal_list_item"
                onClick={(e) => handleSelectRefundReason(item?.key)}
              >{item?.value}</div>
            ))}
          </div>
        </div>
      </Modal>
      <Modal
        visible={confirmRefund}
        className="confirmRefund"
        transparent
        maskClosable={false}
        onClose={() => setConfirmRefund(false)}
      >
        <div className="confirmRefund_content">
          <div className="confirmRefund_title">{ReplaceText('X', params.ticketNum, TLang('正在退订X张电影票', 'home', false, false, null), false)}</div>
          <div className="confirmRefund_text">{params?.serviceChargeExplain}</div>
          <div className="confirmRefund_button">
            <div className="confirmRefund_button_left" onClick={() => setConfirmRefund(false)}>{TLang('取消', 'home', false, false, null)}</div>
            <div className="confirmRefund_button_right" onClick={() => applyRefundClick()}>{TLang('确定', 'home', false, false, null)}</div>
          </div>
        </div>
      </Modal>
    </div>
  );
};


const mapStateToProps = ({ initData }) => ({ unionConfig: initData.unionConfig });
export default withRouter(connect(mapStateToProps)(ApplyRefund));
